import {
  ref,
  onMounted,
  onUnmounted,
  defineComponent,
  computed,
} from "@vue/composition-api";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";
import { JSConn } from "@/utilities/js-conn";

export default defineComponent({
  name: "mWorkOrderShow",
  props: {
    workOrderId: {
      type: String,
      required: true,
    },
  },
  components: {
    LoadingAnimation,
  },

  setup(props, ctx) {
    let $store = ctx.root.$store;
    let dataLoaded = ref(false);
    let loadingMessage = ref(
      "Please wait while the task is pulled in from the api...",
    );

    const workOrder = computed(() => {
      return $store.getters.workOrder;
    });

    const reloadWorkOrder = () => {
      dataLoaded.value = false;
      loadWorkOrder().then(() => {
        dataLoaded.value = true;
      });
    };

    const loadWorkOrder = () => {
      const jsConnWorkOrder = new JSConn();

      jsConnWorkOrder.formParams = {
        id: props.workOrderId,
      };

      const dataPromises = [$store.dispatch("needWorkOrder", jsConnWorkOrder)];

      return Promise.all(dataPromises);
    };

    onMounted(() => {
      loadWorkOrder().then(() => {
        dataLoaded.value = true;
        // turn on the workOrder mode to turn on the menu
        $store.dispatch("setWorkOrderMode", true);
      });
    });

    onUnmounted(() => {
      $store.dispatch("setWorkOrderMode", false);
    });

    return {
      dataLoaded,
      loadingMessage,

      workOrder,
      reloadWorkOrder,
    };
  },
});
